<div id="group-company-management-view-list">
    <div class="group-list-filter">
        <div class="group-search-wrapper">
            <div class="group-search-block">
                <input
                    type="text"
                    class="group-search-input"
                    name="search"
                    [(ngModel)]="searchText"
                    autocomplete="off"
                    placeholder="Buscar grupo" />
                <button type="button"></button>
            </div>
        </div>
    </div>

    <div class="group-list">
        <ul>
            <ng-container *ngFor="let grupo of gruposFiltrados; trackBy: trackByGrupoId">
                <li (click)="onSelectGrupo(grupo)">
                    <a [ngClass]="{ 'selected': grupo.grupoId === selectedGrupo?.grupoId }">
                        <span>{{ grupo.nombre }}</span>
                    </a>
                </li>
            </ng-container>
        </ul>
    </div>

    <div class="group-actions">
        <button type="button" class="btn-add-group" (click)="addNewGrupo()">
            <span>+</span>
        </button>
    </div>
</div>